(function () {
  if (customElements.get('pdp-first-order-gift')) return;

  class PdpFirstOrderGift extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form) return;

      this.button = this.form.querySelector('[type="submit"]');

      this.onSubmit = this.onSubmit.bind(this);
      document.addEventListener('submit', this.onSubmit, true);
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this.onSubmit, true);
    }

    onSubmit(event) {
      if (event.target !== this.form) return;
      if (event.defaultPrevented) return;

      var formData = new FormData(this.form);
      var plan = parseInt(formData.get('selling_plan'), 10);
      if (!plan) return; // one-time purchase: add the normal product
      var variantId = parseInt(formData.get('id'), 10);
      if (!variantId) return;

      event.preventDefault();
      event.stopPropagation();

      var quantity = parseInt(formData.get('quantity'), 10) || 1;

      // Keep any line item properties (e.g. "line_item_property" blocks) on the main product.
      var properties = null;
      formData.forEach(function (value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (!match) return;
        properties = properties || {};
        properties[match[1]] = value;
      });

      this.addToCart(variantId, plan, quantity, properties);
    }

    addToCart(variantId, sellingPlan, quantity, properties) {
      if (this.button && this.button.getAttribute('aria-disabled') === 'true') return;

      var self = this;
      var giftId = parseInt(this.dataset.giftVariant, 10);
      var mainItem = { id: variantId, quantity: quantity, selling_plan: sellingPlan };
      if (properties) mainItem.properties = properties;

      this.setLoading(true);

      this.fetchCart()
        .then(function (cart) {
          var giftInCart =
            cart &&
            (cart.items || []).some(function (item) {
              return item.variant_id === giftId;
            });
          var items = [mainItem];
          if (!giftInCart) {
            // Gift is one-time (no selling_plan). The _free_gift_for property lets
            // free-gift-guard.js auto-remove it when the main subscription is removed.
            items.push({
              id: giftId,
              quantity: 1,
              properties: { _free_gift_for: String(self.dataset.productId || '') }
            });
          }
          return self.submitItems(items).then(function (parsed) {
            if (parsed.status && items.length > 1) {
              // Gift could not be added (e.g. sold out): still add the subscription on its own.
              return self.submitItems([mainItem]);
            }
            return parsed;
          });
        })
        .then(function (parsed) {
          if (!parsed) return;
          if (parsed.status) {
            self.showError(parsed.description || parsed.message || 'Unable to add to cart');
            return;
          }
          return self.refreshCart(parsed);
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          self.setLoading(false);
        });
    }

    submitItems(items) {
      var sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
      );

      var hasFox = window.FoxTheme && FoxTheme.utils && FoxTheme.utils.fetchConfig;
      var config = hasFox
        ? FoxTheme.utils.fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/javascript' } };
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Content-Type'] = 'application/json';
      config.body = JSON.stringify({
        items: items,
        sections: sections,
        sections_url: window.location.pathname
      });

      var addUrl = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_add_url) || '/cart/add';
      return fetch(addUrl, config).then(function (response) {
        return response.json();
      });
    }

    fetchCart() {
      var hasFox = window.FoxTheme && FoxTheme.utils && FoxTheme.utils.fetchConfig;
      var config = hasFox ? FoxTheme.utils.fetchConfig('json', 'GET') : { headers: { Accept: 'application/json' } };
      var cartUrl = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_url) || '/cart';
      return fetch(cartUrl, config)
        .then(function (response) {
          return response.json();
        })
        .catch(function () {
          return null;
        });
    }

    refreshCart(parsed) {
      var self = this;
      return this.fetchCart().then(function (cartJson) {
        if (!cartJson) return;
        cartJson['sections'] = parsed['sections'];
        if (window.FoxTheme && FoxTheme.pubsub) {
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
        }
        document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: parsed } }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') {
          drawer.show(self.button);
        } else {
          window.location.href = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_url) || '/cart';
        }
      });
    }

    setLoading(loading) {
      if (!this.button) return;
      if (loading) {
        this.button.classList.add('btn--loading');
        this.button.setAttribute('aria-disabled', 'true');
      } else {
        this.button.classList.remove('btn--loading');
        this.button.removeAttribute('aria-disabled');
      }
    }

    showError(message) {
      var wrapper = this.form.closest('.product-form');
      var errorEl = wrapper ? wrapper.querySelector('.product-form__error-message') : null;
      if (errorEl) {
        errorEl.removeAttribute('hidden');
        errorEl.innerText = message;
        var errorWrapper = wrapper.querySelector('.product-form__error-message-wrapper');
        if (errorWrapper) errorWrapper.removeAttribute('hidden');
      } else {
        alert(message);
      }
    }
  }

  customElements.define('pdp-first-order-gift', PdpFirstOrderGift);
})();
